<h2 mat-dialog-title>Add Traveler + Address</h2>
<mat-dialog-content style="padding-top: 16px; overflow: visible; min-width: 720px;">
  <form [formGroup]="form">
    <h3 style="margin: 8px 0 8px;">Identity</h3>
    <div style="display: grid; grid-template-columns: 1fr 2fr 1fr; gap: 12px;">
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Traveler ID</mat-label>
        <input matInput type="number" formControlName="travelerId">
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Traveler Name</mat-label>
        <input matInput formControlName="travelerName" placeholder="First Last">
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Gender</mat-label>
        <mat-select formControlName="gender">
          <mat-option value="">--</mat-option>
          <mat-option value="M">M</mat-option>
          <mat-option value="F">F</mat-option>
          <mat-option value="X">X</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email">
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Phone</mat-label>
        <input matInput formControlName="phone">
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Mobile</mat-label>
        <input matInput formControlName="mobilePhone">
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Date of Birth</mat-label>
        <input matInput [matDatepicker]="dobPicker" formControlName="dateOfBirth">
        <mat-datepicker-toggle matIconSuffix [for]="dobPicker"></mat-datepicker-toggle>
        <mat-datepicker #dobPicker></mat-datepicker>
      </mat-form-field>
      <div style="display: flex; align-items: center;">
        <mat-checkbox formControlName="isMainContact">Main contact</mat-checkbox>
      </div>
    </div>

    <h3 style="margin: 12px 0 8px;">Passport (optional)</h3>
    <div style="display: grid; grid-template-columns: 1fr 1fr 2fr; gap: 12px;">
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Passport #</mat-label>
        <input matInput formControlName="passportNumber">
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Country</mat-label>
        <input matInput formControlName="passportCountry">
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Full Name on Passport</mat-label>
        <input matInput formControlName="passportFullName">
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Issue Date</mat-label>
        <input matInput [matDatepicker]="issuePicker" formControlName="passportIssueDate">
        <mat-datepicker-toggle matIconSuffix [for]="issuePicker"></mat-datepicker-toggle>
        <mat-datepicker #issuePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Expiry Date</mat-label>
        <input matInput [matDatepicker]="expiryPicker" formControlName="passportExpiryDate">
        <mat-datepicker-toggle matIconSuffix [for]="expiryPicker"></mat-datepicker-toggle>
        <mat-datepicker #expiryPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <h3 style="margin: 12px 0 8px;">Address</h3>
    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Address Line 1</mat-label>
        <input matInput formControlName="address1">
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Address Line 2</mat-label>
        <input matInput formControlName="address2">
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>City</mat-label>
        <input matInput formControlName="city">
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>State/Province</mat-label>
        <input matInput formControlName="state">
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Country</mat-label>
        <input matInput formControlName="country" placeholder="United States, Canada, etc.">
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Postal Code</mat-label>
        <input matInput formControlName="postalCode">
      </mat-form-field>
    </div>
    <p style="color: #666; font-size: 12px; margin-top: 8px;">
      Address fields live directly on the traveler row. The ERP customer mapping pulls them from
      the <em>main-contact</em> traveler (else the first one).
    </p>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">Add Traveler</button>
</mat-dialog-actions>
